import { render, staticRenderFns } from "./formula-preview.vue?vue&type=template&id=a5107fa6&"
import script from "./formula-preview.vue?vue&type=script&lang=js&"
export * from "./formula-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports